import styled from '@emotion/styled';
import Theme from 'App.theme';
interface StageContainerProps {
  height?: number;
}

export const StageContainer = styled.div<StageContainerProps>`
  border: 5px solid ${Theme.greys.GREY1};
  border-radius: 5px;
  margin: 5px 5px 5px 0px;
  box-shadow: 'none';
`;
